(() => {
  if (customElements.get('threewe-newsletter')) return;
  const dismissedKey = 'threewe-newsletter-dismissed-at';
  const subscribedKey = 'threewe-newsletter-subscribed';
  const read = (key) => { try { return localStorage.getItem(key); } catch (_) { return null; } };
  const write = (key, value) => { try { localStorage.setItem(key, value); } catch (_) {} };

  customElements.define('threewe-newsletter', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || !this.dialog.showModal) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelector('[data-newsletter-close]').addEventListener('click', () => this.close(), options);
      this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.close(); }, options);
      this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog) this.close(); }, options);
      this.dialog.addEventListener('close', () => document.documentElement.classList.remove('threewe-newsletter-open'), options);
      this.querySelector('[data-newsletter-motion]').addEventListener('click', (event) => {
        const paused = this.dialog.toggleAttribute('data-paused');
        event.currentTarget.setAttribute('aria-pressed', String(paused));
        event.currentTarget.textContent = paused ? 'Play globes' : 'Pause globes';
      }, options);
      this.querySelector('form').addEventListener('submit', () => {
        const button = this.querySelector('[type="submit"]');
        if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
      }, options);
      window.addEventListener('pageshow', () => {
        const button = this.querySelector('[type="submit"]');
        if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
      }, options);
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('a[href="#elite-newsletter"]');
        if (trigger) { event.preventDefault(); this.open(); }
      }, options);
      const success = this.querySelector('[data-newsletter-success]');
      if (success) write(subscribedKey, '1');
      const response = success || this.querySelector('[data-newsletter-error]');
      const preview = new URLSearchParams(location.search).get('newsletter_preview') === '1';
      if (response || preview || this.dataset.designMode === 'true') {
        this.open();
        if (success) success.focus();
        return;
      }
      const dismissed = Number(read(dismissedKey));
      const cooldown = Number(this.dataset.dismissDays || 7) * 86400000;
      if (this.dataset.subscribed === 'true' || read(subscribedKey) === '1' || (dismissed && Date.now() - dismissed < cooldown)) return;
      this.timer = setTimeout(() => {
        // Do not interrupt another dialog or someone already entering information.
        if (document.querySelector('dialog[open], cart-drawer.active') || document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) return;
        this.open();
      }, Number(this.dataset.delay || 3000));
    }
    open() {
      if (this.dialog.open) return;
      this.previousFocus = document.activeElement;
      this.dialog.showModal();
      document.documentElement.classList.add('threewe-newsletter-open');
      this.querySelector('.threewe-newsletter__title').focus({ preventScroll: true });
    }
    close() {
      write(dismissedKey, String(Date.now()));
      this.dialog.close();
      if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
      document.documentElement.classList.remove('threewe-newsletter-open');
      this.initialized = false;
    }
  });
})();
